import { render } from "./ClassPricing.vue?vue&type=template&id=4de3b694&scoped=true"
import script from "./ClassPricing.vue?vue&type=script&lang=js"
export * from "./ClassPricing.vue?vue&type=script&lang=js"

import "./ClassPricing.vue?vue&type=style&index=0&id=4de3b694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de3b694"]])

export default __exports__